const tableHeader = [
  {
    title: 'payment_file.transactions_list.header.transaction_at',
  },
  {
    title: 'payment_file.transactions_list.header.wallet_id',
  },
  {
    title: 'payment_file.transactions_list.header.mobile_no',
  },
  {
    title: 'payment_file.transactions_list.header.transaction_id',
  },
  {
    title: 'payment_file.transactions_list.header.merchant_tx_short_id',
  },
  {
    title: 'payment_file.transactions_list.header.reference_no',
  },
  {
    title: 'payment_file.transactions_list.header.amount',
  },
  {
    title: 'payment_file.transactions_list.header.batch_name',
  },
  {
    title: 'payment_file.transactions_list.header.status',
  },
];

export default tableHeader;
